<template>
  <div class="layout-box">
      <transition name="fade">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" :dataRefresh="datarefresh"/>
        </keep-alive>
      </transition>
      <transition name="fade">
        <router-view v-if="!$route.meta.keepAlive" :dataRefresh="datarefresh"/>
      </transition>
  </div>
</template>

<script>
import myStorage from "../../bll/utils";
class intervelRefreshObj {
  constructor () {
    this.subs = Object.create(null)
  }
  $ons (eventType, handler) {
    this.subs[eventType] = this.subs[eventType] || []
    this.subs[eventType].push(handler)
  }
  $emits (eventType) {
    this.subs[eventType].forEach(handler => {
      handler()
    })
  }
}
export default {
  name: 'LayoutIndex',
  data () {
    return {
      datarefresh: null,
      refreshtime: process.env.REFRESHTIME
    }
  },
  created () {
    let $this = this
    myStorage.setItem('localStorage','isreset', true ,process.env.EXPIRATION_TIME)
    this.datarefresh = new intervelRefreshObj()
    setInterval(function () {
      $this.datarefresh.$emits('Refresh')
      const isreset=localStorage.getItem('isreset')
      const parsedData = JSON.parse(isreset)
      const currentTimestamp = new Date().getTime()
      if (currentTimestamp - parsedData.timestamp >= parsedData.expire) {
        window.location.reload()
      }
    }, process.env.REFRESHTIME)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: 100%;
}

.fade-enter,.fade-leave-to{
  opacity: 0;
}

.fade-enter-to,.fade-leave{
  opacity: 1;
}

.fade-enter-active,.fade-leave-active{
  transition: opacity 0.6s;
}

</style>



// WEBPACK FOOTER //
// src/views/layout/layout-index.vue